export default function ChevronDownIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 14.5557C9.72331 14.5557 9.47152 14.445 9.24463 14.2236L2.92773 7.75732C2.83366 7.66878 2.76172 7.56917 2.71191 7.4585C2.66764 7.34229 2.64551 7.21777 2.64551 7.08496C2.64551 6.90234 2.68701 6.73633 2.77002 6.58691C2.85856 6.4375 2.97477 6.32129 3.11865 6.23828C3.26253 6.14974 3.42578 6.10547 3.6084 6.10547C3.87402 6.10547 4.10645 6.20508 4.30566 6.4043L10.4067 12.6548H9.60156L15.6943 6.4043C15.8936 6.20508 16.126 6.10547 16.3916 6.10547C16.5742 6.10547 16.7375 6.14974 16.8813 6.23828C17.0252 6.32129 17.1387 6.4375 17.2217 6.58691C17.3102 6.73633 17.3545 6.90234 17.3545 7.08496C17.3545 7.34505 17.2604 7.56917 17.0723 7.75732L10.7554 14.2236C10.6502 14.3343 10.534 14.4173 10.4067 14.4727C10.2795 14.528 10.1439 14.5557 10 14.5557Z" />
    </svg>
  );
}
